import React, { forwardRef } from 'react';

import { useRecoilValue } from 'recoil';

import { userState as state } from 'components/state';

import Loader from '../Loader/Loader';
import { ia, iaRa } from '../../../lib/helpers/utility';
import { currentPractice } from '../../practice/practiceState';

import ReceiptHeader from './components/Header/Header';
import ReceiptItems from './components/ReceiptItems/ReceiptItems';
import ReceiptSummary from './components/ReceiptSummary/ReceiptSummary';
import ReceiptTransactions from './components/ReceiptTransactions/ReceiptTransactions';
import ReceiptUpcomingAppointments from './components/ReceiptUpcomingAppointments/ReceiptUpcomingAppointments';

const Receipt = forwardRef(({ receipt, walkout = false }, ref) => {
  const patient = receipt?.patient;
  const transaction = receipt?.transaction;
  const transactions = receipt?.transactions;

  let practice = useRecoilValue(currentPractice);
  const userState = useRecoilValue(state);

  const isPatient = !userState.logged_in || (userState?.logged_in && !practice?.id);

  if (!practice.id) {
    practice = receipt?.practice;
  }

  if (!practice)
    return (
      <div className="flex flex-1 items-center justify-center">
        <Loader color="primary" size={40} />
      </div>
    );

  const { timezone } = practice || {};

  const currentTransactions = ia(receipt?.transactions) ? receipt?.transactions : [transaction];

  return (
    <div className="flex flex-1 flex-col gap-6 overflow-y-auto bg-white pb-6 md:gap-10">
      <div
        ref={ref}
        key={receipt?.transaction?.id}
        className="flex w-full flex-1 flex-col bg-white pb-2 lg:min-w-[764px] md:min-w-full md:pb-6"
        data-receipt-id={receipt?.transaction?.id}>
        <ReceiptHeader receipt={{ ...receipt, practice }} />
        <div className="flex flex-col justify-center gap-3 px-6 py-3.5 sm:px-2">
          {iaRa(currentTransactions).map((transaction, index) => {
            return (
              <ReceiptItems
                key={transaction?.id}
                index={index}
                transaction={transaction}
                hasMultipleTransactions={currentTransactions?.length > 1}
              />
            );
          })}
          <ReceiptSummary
            isPatient={isPatient}
            transaction={transaction}
            unallocatedAmount={receipt?.unallocatedAmount}
            transactions={ia(transactions) ? transactions : [transaction]}
            walkout={walkout}
            walkoutTransactions={iaRa(receipt?.walkoutTransactions)}
          />
        </div>
      </div>
      {walkout && (
        <ReceiptTransactions
          transactions={iaRa(receipt?.walkoutTransactions)}
          timezone={timezone}
        />
      )}
      <ReceiptUpcomingAppointments
        patientId={transaction?.patient_id || patient?.id}
        practiceId={practice?.id}
        timezone={timezone}
      />
    </div>
  );
});

export default Receipt;
